export default <T extends object>(condition: boolean, obj: T | (() => T)): T | {} => (condition ? (typeof obj === 'function' ? obj() : obj) : {});
